import React from 'react';
import PersonalInfo from 'ViewModels/Components/MyAccount/PersonalInfo/PersonalInfo';
import PersonalInfoActions from './PersonalInfoActions';
import ChangeUsername from './ChangeUserName';
import ChangePassword from '../ChangePassword/ChangePasswordContainer';

export default class PersonalInfoContainer extends React.Component {
    constructor(props){
        super(props);
        let showUserName = window.jenkon.useEmailAsUserName == 'inActive';

        this.state = {
            componentToShow: <PersonalInfo changeView={this.switchComponentInView.bind(this)} resources={this.props.resources} setView={this.props.setView.bind(this)} showUserName={showUserName} />
            };
    }

componentDidMount() {
        PersonalInfoActions.getPhoneFormats();
        PersonalInfoActions.getPersonalInfo();
    }

    switchComponentInView(name) {
        let showUserName = window.jenkon.useEmailAsUserName == 'inActive';
        switch (name) {
        case 'Username':
            this.setState({
                componentToShow: <ChangeUsername cancelView={this.switchComponentInView.bind(this)} resources={this.props.resources}/>
            });
            break;
        case 'PersonalInfo':
                this.setState({
                    componentToShow: <PersonalInfo changeView={this.switchComponentInView.bind(this)} resources={this.props.resources} setView={this.props.setView.bind(this)} showUserName={showUserName} />
            });
            break;
        case 'Password':
            this.setState({
                componentToShow: <ChangePassword changeView={this.switchComponentInView.bind(this)} resources={this.props.resources}/>
            });
            break;
        default:
            this.setState({
                componentToShow: <PersonalInfo changeView={this.switchComponentInView.bind(this)} resources={this.props.resources} setView={this.props.setView.bind(this)}/>
            });
            break;
        }
    }

    render() {

        return (
            <div className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title">{window.jenkon.resources['PWS.MyAccount.PersonalInfoTitle']}</div>
					<div className="description">{window.jenkon.resources['PWS.MyAccount.PersonalInfoPageDescription']}</div>
				</div>
				<div className="section-wrapper clearfix">
					<a href="javascript:void(0);" className="section-back-link" onClick={this.props.setView.bind(this)}>{this.props.resources["PWS.MyAccount.BackToAccountButton"]}</a>
					<div className="dotted-HR"></div>
					<div>
						{this.state.componentToShow}
					</div>
				</div>
			</div>);
    }
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/PersonalInfo/PersonalInfoContainer.js